import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const MarginAccountDepositWithdrawalsServiceContext = createContext(undefined)

const MarginAccountDepositWithdrawalsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={MarginAccountDepositWithdrawalsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        create: async (marginAccountId, payload) => {
          const {data} = await axios.post(`/api/v1/org/margin_accounts/${marginAccountId}/deposit_withdrawals`, payload)
          return data
        },
        get: async (id) => {
          const {data} = await axios.get(`/api/v1/org/margin_account_deposit_withdrawals/${id}`)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/org/margin_account_deposit_withdrawals${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        update: async (id, payload) => {
          const {data} = await axios.patch(`/api/v1/org/margin_account_deposit_withdrawals/${id}`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

MarginAccountDepositWithdrawalsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useMarginAccountDepositWithdrawalsService = () => {
  const context = useContext(MarginAccountDepositWithdrawalsServiceContext)
  if (context === undefined) {
    throw new Error('MarginAccountDepositWithdrawalsServiceContext was not provided. Make sure your component is a child of the MarginAccountDepositWithdrawalsServiceProvider.')
  }
  return context
}

const useMarginAccountDepositWithdrawalsQuery = ({query, ...otherProps}) => {
  const marginAccountDepositWithdrawalsService = useMarginAccountDepositWithdrawalsService()
  return useSimpleQuery({
    queryKey: `margin_account_deposit_withdrawals-list-${JSON.stringify(query)}`,
    queryFn: async () => marginAccountDepositWithdrawalsService.list(query),
    ...otherProps
  })
}

const useMarginAccountDepositWithdrawalQuery = ({id, enabled, ...otherProps}) => {
  const marginAccountDepositWithdrawalsService = useMarginAccountDepositWithdrawalsService()
  return useSimpleQuery({
    queryKey: `margin_account_deposit_withdrawals-get-${id}`,
    queryFn: async () => marginAccountDepositWithdrawalsService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {MarginAccountDepositWithdrawalsServiceProvider, useMarginAccountDepositWithdrawalsService, useMarginAccountDepositWithdrawalsQuery, useMarginAccountDepositWithdrawalQuery}
